import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/usr/src/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["range"] */ "/usr/src/app/src/components/Ackodrive/common/utils.ts");
;
import(/* webpackMode: "eager" */ "/usr/src/app/src/components/Ackodrive/footer/common/companyAddress/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocialIconMainWrapper","SITitle","SocialIconsWrapper","SocialIcon"] */ "/usr/src/app/src/components/Ackodrive/footer/common/socialIcons/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopWrapper","DesktopContainer","DesktopCompanyDetails","LinksWrapper","DesktopItemWrapper","DesktopTitle","DesktopLink"] */ "/usr/src/app/src/components/Ackodrive/footer/desktop/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["MobileWrapper","MobileTitle","MobileLink"] */ "/usr/src/app/src/components/Ackodrive/footer/mobile/styles.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Ackodrive/header/globalHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/Ackodrive/ItemsListing/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/src/app/src/components/BottomNavigationMobile/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ModalProvider"] */ "/usr/src/app/src/context/ModalContext/ModalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/usr/src/app/src/context/UserContext/UserContenxt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WidgetProvider"] */ "/usr/src/app/src/context/userWidgetProps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["getR2d2Payload"] */ "/usr/src/app/src/utils/r2d2Payload.ts");
